// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3s8n6","signatureButtonsRight":"ModalSign_signatureButtonsRight__2JmUf"};